module.exports = __webpack_public_path__ + "assets/icon_archive.860de0be.svg";